import styles from "./EnvironmentOptions.module.scss";
import { EnvironmentVariantItem } from "../../EnvironmentVariantItem/EnvironmentVariantItem";
import { useEffect } from "react";
import { getPlayCanvasStringValue } from "../../../../../../../utils/functions/getPlayCanvasStringValue";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../redux/store";
import {
  getEnvironmentActiveValues,
  getUIState,
} from "../../../../../../../redux/reducers/ui/uiSelectors";
import { setEnvironmentActiveValue } from "../../../../../../../redux/reducers/ui/uiReducer";
import { popUp } from "../../../../../../../features/popUp/PopUp";

interface EnvironmentOptionProps {
  optionList: any[];
  proxyName: string;
  stage: any;
}

export const EnvironmentOption = ({
  optionList,
  proxyName,
  stage,
}: EnvironmentOptionProps) => {
  const dispatch = useAppDispatch();
  const environmentActiveValues = useAppSelector(getEnvironmentActiveValues);
  const uiData = useAppSelector(getUIState);

  // @ts-ignore
  const windowPlay = window.containerRef.current.contentWindow.VividMaterialAPI;
  const nodeName = getPlayCanvasStringValue(optionList[0]?.playcanvasString);

  const setVariantsValue = () => {
    const activeCanvasValue = windowPlay.getValueMaterail(
      nodeName,
      proxyName
    )?.name;

    if (activeCanvasValue) {
      const filteredEnvVariants = environmentActiveValues.filter(
        env => env.proxyName !== proxyName
      );
      const newActiveProxyVariantsData = [
        ...filteredEnvVariants,
        { proxyName, proxyValue: activeCanvasValue },
      ];

      dispatch(setEnvironmentActiveValue(newActiveProxyVariantsData));
    } else {
      popUp({ type: "warning", message: "These variants aren't available" });
    }
  };

  useEffect(() => {
    setVariantsValue();
    //set active variant
  }, []);

  useEffect(() => {
    environmentActiveValues.forEach(variant => {
      const { proxyName, proxyValue } = variant;
      windowPlay.setValueName(nodeName, proxyName, proxyValue);
    });
  }, [uiData]);

  const handleSetPlaycanvasValue = ({
    variantId,
    variantName,
    nodeName,
  }: {
    variantId: number;
    variantName: string;
    nodeName: string;
  }) => {
    if (nodeName && proxyName && variantId) {
      windowPlay.setValueName(nodeName, proxyName, variantName);

      setVariantsValue();
    }
  };

  return (
    <div className={styles.wrapper}>
      {optionList.map((proxyVariant, idx) => {
        return (
          <EnvironmentVariantItem
            key={idx}
            proxyVariant={proxyVariant}
            proxyName={proxyName}
            onChangePlaycanvasSetting={handleSetPlaycanvasValue}
          />
        );
      })}
    </div>
  );
};
